import React from "react";
import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  .ant-modal-content {
     width: ${({ width }) => width || "301px"};
    // height: 310px;
    left: calc(50% - 301px / 2 - 0.5px);
    top: calc(50% - 310px / 2);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 124px;
    padding-bottom: 16px !important;
  }
  .ant-modal-footer-section {
    text-align: center !important;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
    align-items: center;
  }
  .ant-modal-footer {
    display: none;
  }
  .Popup-img {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-bottom: 11px;
  }
  .Popup-content {
    span {
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      margin-bottom: 3px;
      text-align:center;
    }
    p {
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      padding: 12px;
      color: #605e5c;
    }
  }
  .themeBtn {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
  }
  .themeBtn-plane {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: #ffff;
    text-align: center;
    outline: none !important;
    margin: 0px 12px;
    border: 1px solid #ea655b;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ea655b;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: #fff;
      border: 1px solid var(--theme-color-hover);
    }
  }
  .ant-modal-close-x {
    display: none;
  }
  .themeBtn svg {
    position: relative;
    top: 2px;
    border: 1px solid #fff;
    padding: 2px;
    border-radius: 4px;
  }
  .themeBtn-plane {
    .plusPopUpBorder {
      position: relative;
      // top: 2px;
      border: 1px solid var(--theme-color);
      padding: 2px;
      border-radius: 4px;
      width: 13px;
      height: 13px;
      svg {
        transform: rotate(133deg);
        top: -8px;
        right: 1px;
      }
    }
  }
  .top-close-icon {
    display:flex;
    justify-content:flex-end;
    cursor:pointer;
  }
`;

const MultiStageStyledModal = styled(Modal)`
  .ant-modal-content {
    width: 462px;
    // height: 310px;
    left: calc(50% - 301px / 2 - 0.5px);
    top: calc(50% - 310px / 2);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 124px;
    padding-bottom: 16px !important;
  }
  .ant-modal-footer-section {
    text-align: center !important;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
    align-items: center;
  }
  .ant-modal-footer {
    display: none;
  }
  .Popup-img {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-bottom: 11px;
  }
  .Popup-content {
    span {
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      margin-bottom: 3px;
      text-align:center;
    }
    p {
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      padding: 12px;
      color: #605e5c;
    }
  }
  .themeBtn {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
  }
  .themeBtn-plane {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: #ffff;
    text-align: center;
    outline: none !important;
    margin: 0px 12px;
    border: 1px solid #ea655b;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ea655b;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: #fff;
      border: 1px solid var(--theme-color-hover);
    }
  }
  .ant-modal-close-x {
    display: none;
  }
  .themeBtn svg {
    position: relative;
    top: 2px;
    border: 1px solid #fff;
    padding: 2px;
    border-radius: 4px;
  }
  .themeBtn-plane {
    .plusPopUpBorder {
      position: relative;
      // top: 2px;
      border: 1px solid var(--theme-color);
      padding: 2px;
      border-radius: 4px;
      width: 13px;
      height: 13px;
      svg {
        transform: rotate(133deg);
        top: -8px;
        right: 1px;
      }
    }
  }
`;

const MultiStageModalPopup = (props) => {
  return (
      <MultiStageStyledModal
        visible={props.visible}
        title={props?.title}
        onCancel={props?.onCancel}
        maskStyle={{ top: 61, background: "#00000033" }}
        className={props?.className}
      >
        {props.children}
      </MultiStageStyledModal>
  );
};

const ModalPopup = (props) => {
  return (
      <StyledModal
        visible={props.visible}
        title={props?.title}
        onCancel={props?.onCancel}
        maskStyle={{ top: 61, background: "#00000033" }}
        className={props?.className}
        width={props?.width}
      >
        {props.children}
      </StyledModal>
  );
};

// Reset password confirmatiomn Modal

const SuccessResetPassword = () => {
  Modal.success({
    title: "Password Changed",
    content: <p>Your password has been changed successfully</p>,
  });
};
export { ModalPopup, SuccessResetPassword, MultiStageModalPopup };
